function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("ellipse", {
  cx: 1007.29,
  cy: 789.73,
  rx: 19.99,
  ry: 48.53,
  transform: "rotate(-45 849.945 919.851)",
  fill: "#899689",
  opacity: 0.1
});

var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 872.63,
  cy: 705.7,
  rx: 10.73,
  ry: 14.05,
  fill: "#3f3d56"
});

var _ref3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 872.63,
  cy: 688.53,
  rx: 10.73,
  ry: 14.05,
  fill: "#3f3d56"
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 872.63,
  cy: 671.36,
  rx: 10.73,
  ry: 14.05,
  fill: "#3f3d56"
});

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 872.63,
  cy: 654.19,
  rx: 10.73,
  ry: 14.05,
  fill: "#3f3d56"
});

var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 872.63,
  cy: 637.02,
  rx: 10.73,
  ry: 14.05,
  fill: "#3f3d56"
});

var _ref7 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 872.63,
  cy: 619.85,
  rx: 10.73,
  ry: 14.05,
  fill: "#3f3d56"
});

var _ref8 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 872.63,
  cy: 602.68,
  rx: 10.73,
  ry: 14.05,
  fill: "#3f3d56"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M912.8 485.18a51.13 51.13 0 004-5.88l-28.2-4.63 30.5.22a51.54 51.54 0 001-40.73l-40.91 21.23 37.71-27.74a51.41 51.41 0 10-84.9 57.53 51.16 51.16 0 00-5.86 9.37l36.6 19-39-13.1a51.45 51.45 0 008.29 48.27 51.4 51.4 0 1080.8 0 51.41 51.41 0 000-63.56z",
  fill: "#899689"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M821 516.96a51.16 51.16 0 0011 31.78 51.4 51.4 0 1080.8 0c6.89-8.74-91.8-37.55-91.8-31.78z",
  opacity: 0.1
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "#444053",
  d: "M846.97 0v720l-244-34-296.61 60.51-2.39.49-236-65V56l245-56 268 56 10.19-2.15L846.97 0z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M805.97 39.32v644.21l-218.31-30.42-265.39 54.14-2.14.43-211.16-58.15V89.42l219.22-50.1 239.78 50.1 9.12-1.92 228.88-48.18z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M602.97 686l-296.61 60.51L312.97 0l268 56 10.19-2.15L602.97 686z"
});

var _ref14 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.3,
  fill: "none",
  stroke: "#444053",
  strokeMiterlimit: 10,
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("path", {
  d: "M573.35 138l.12 209.5h87v-86h149l17.5-22.44M88.97 204.5h323.5l20-9h8v202h140l6 18v91h108V619M483.2 619V397.5M826.97 559.66H483.2M740.87 138v481M87.97 517.14h739M177.91 619V138M349.69 138v481M88.97 259.5l571.5 2M255.3 138.87V619"
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.97 370.82h261.72L483.2 517.14M512.12 138v259.5M483.2 443.98h343.77"
}));

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fill: "#899689",
  d: "M585.97 442h-101v-44l95.5-.5 6 17-.5 27.5z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M535.97 214a55.28 55.28 0 00-55.28 55.28c0 30.53 55.28 129.72 55.28 129.72s55.28-99.15 55.28-129.72A55.28 55.28 0 00535.97 214zm0 78.86a24.32 24.32 0 1124.32-24.32 24.32 24.32 0 01-24.32 24.31z",
  fill: "#899689"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M535.97 214a55.28 55.28 0 00-55.28 55.28c0 30.53 55.28 129.72 55.28 129.72s55.28-99.15 55.28-129.72A55.28 55.28 0 00535.97 214zm0 78.86a24.32 24.32 0 1124.32-24.32 24.32 24.32 0 01-24.32 24.31z",
  opacity: 0.1
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M535.97 222a55.28 55.28 0 00-55.28 55.28c0 30.53 55.28 129.72 55.28 129.72s55.28-99.15 55.28-129.72A55.28 55.28 0 00535.97 222zm0 78.86a24.32 24.32 0 1124.32-24.32 24.32 24.32 0 01-24.32 24.31z",
  fill: "#899689"
});

var _ref19 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 649.86,
  cy: 806.61,
  rx: 33.45,
  ry: 13.78,
  transform: "rotate(-23.3 403.328 1104.861)",
  fill: "#899689",
  opacity: 0.1
});

var _ref20 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 511.39,
  cy: 727.97,
  rx: 7.4,
  ry: 9.68,
  fill: "#3f3d56"
});

var _ref21 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 511.39,
  cy: 716.13,
  rx: 7.4,
  ry: 9.68,
  fill: "#3f3d56"
});

var _ref22 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 511.39,
  cy: 704.3,
  rx: 7.4,
  ry: 9.68,
  fill: "#3f3d56"
});

var _ref23 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 511.39,
  cy: 692.47,
  rx: 7.4,
  ry: 9.68,
  fill: "#3f3d56"
});

var _ref24 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 511.39,
  cy: 680.63,
  rx: 7.4,
  ry: 9.68,
  fill: "#3f3d56"
});

var _ref25 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 511.39,
  cy: 668.8,
  rx: 7.4,
  ry: 9.68,
  fill: "#3f3d56"
});

var _ref26 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 511.39,
  cy: 656.97,
  rx: 7.4,
  ry: 9.68,
  fill: "#3f3d56"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M483.7 575.98a36.12 36.12 0 01-2.76-4l19.44-3.2-21 .16a35.54 35.54 0 01-.68-28.07l28.2 14.58-26-19.12a35.43 35.43 0 1158.51 39.65 35.55 35.55 0 014 6.46l-25.21 13.11 26.9-9a35.45 35.45 0 01-5.71 33.27 35.43 35.43 0 11-55.69 0 35.44 35.44 0 010-43.81z",
  fill: "#899689"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M546.97 597.85a35.28 35.28 0 01-7.58 21.91 35.43 35.43 0 11-55.69 0c-4.75-6 63.27-25.85 63.27-21.91z",
  opacity: 0.1
});

var _ref29 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 186.29,
  cy: 767.73,
  rx: 19.99,
  ry: 48.53,
  transform: "rotate(-45 28.942 897.852)",
  fill: "#899689",
  opacity: 0.1
});

var _ref30 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 51.63,
  cy: 683.7,
  rx: 10.73,
  ry: 14.05,
  fill: "#3f3d56"
});

var _ref31 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 51.63,
  cy: 666.53,
  rx: 10.73,
  ry: 14.05,
  fill: "#3f3d56"
});

var _ref32 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 51.63,
  cy: 649.36,
  rx: 10.73,
  ry: 14.05,
  fill: "#3f3d56"
});

var _ref33 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 51.63,
  cy: 632.19,
  rx: 10.73,
  ry: 14.05,
  fill: "#3f3d56"
});

var _ref34 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 51.63,
  cy: 615.02,
  rx: 10.73,
  ry: 14.05,
  fill: "#3f3d56"
});

var _ref35 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 51.63,
  cy: 597.85,
  rx: 10.73,
  ry: 14.05,
  fill: "#3f3d56"
});

var _ref36 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 51.63,
  cy: 580.68,
  rx: 10.73,
  ry: 14.05,
  fill: "#3f3d56"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M91.8 463.18a51.13 51.13 0 004-5.88l-28.2-4.63 30.5.22a51.54 51.54 0 001-40.73l-40.91 21.23 37.71-27.74A51.41 51.41 0 1011 463.18a51.16 51.16 0 00-5.86 9.37l36.6 19-39-13.1a51.45 51.45 0 008.29 48.27 51.4 51.4 0 1080.8 0 51.41 51.41 0 000-63.56z",
  fill: "#899689"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M0 494.96a51.16 51.16 0 0011 31.78 51.4 51.4 0 1080.8 0C98.69 518 0 489.19 0 494.96z",
  opacity: 0.1
});

var SvgMaps = function SvgMaps(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: 923.8,
    height: 753.71,
    viewBox: "0 0 923.8 753.71"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38);
};

export default "data:image/svg+xml;base64,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";
export { SvgMaps as ReactComponent };